const LOCATION_INFO = {

  // 距離の単位変換閾値
  distance: {
    decimalPlaces: 1
  },

  // デバウンス待機時間（ミリ秒）
  debounceWaitMs: 500,
  // 住所更新の最小間隔（ミリ秒）
  updateIntervalMs: 1000,
  // APIリクエストのタイムアウト（ミリ秒）
  apiRequestTimeoutMs: 10000,
  // メッセージ
  messages: {
    addressError: '住所の取得に失敗しました',
    unexpectedData: 'エラー: 予期せぬデータ構造',
    stationTimeout: '駅データの取得がタイムアウトしました',
    addressSearching: '住所を検索中...',
    addressNotFound: '住所情報なし',
    addressFetchFailed: '住所情報を取得できませんでした'
  },
};

export default LOCATION_INFO;